import { render } from "./comparison-table.view.vue?vue&type=template&id=293381b6&scoped=true&ts=true"
import script from "./comparison-table.view.vue?vue&type=script&lang=ts"
export * from "./comparison-table.view.vue?vue&type=script&lang=ts"

import "./comparison-table.view.vue?vue&type=style&index=0&id=293381b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293381b6"]])

export default __exports__